module.exports = __webpack_public_path__ + "img/mongo.56a0c447.png";